import { isEmpty } from './is-empty.js';

export function getTrailElement<T>(array: T[]): Nullable<T> {
  if (isEmpty(array)) {
    return null;
  }

  return array[array.length - 1];
}
